export default {
    freeImg: "https://web-data.zmlearn.com/image/658bcmqBX3GM9xFuPm6NJk/%E7%BC%96%E7%BB%84%204%403x_pc.png",
    teacherIntro: [
        {
            tchImg: 'https://web-data.zmlearn.com/image/v7cXdKK85oadcEKBuRamQp/_png_04.png',
            title: 'Solicitud',
            desc:
                'cuéntanos en lo que quiere que le ayudemos y nuestro sistema le va a hacer coincidir con un tutor en línea. regístrese por una clase de prueba gratuita.',
        },
        {
            tchImg: 'https://web-data.zmlearn.com/image/a742Udpxb7K85Rhey4PMVa/_png_05.png',
            title: 'tutoría individual en línea cara a cara',
            desc: `Reciba clases de forma de videoconferencia a través del móvil o tablet, que incorporan chats,
            photos, deberes, pizarra, colaboración de documentos, y gráficos. Tutoría en cuando y donde quiera. Pizarra digital, función de grabación, pantalla compartida y mucho más.`,
        },
        {
            tchImg: 'https://web-data.zmlearn.com/image/qYFYcJ8VReioxkDXSXpdjq/_png_06.png',
            title: 'Reseña',
            desc: `Después de terminar la clase, tanto el tutor como el estudiante tendrá la oportunidad de tomar 
            nota de entre sí para mantener una buena comunicación.`
        },
    ],
}